import Divider from "@material-ui/core/Divider";
import IconButton from "@material-ui/core/IconButton";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import PropTypes from "prop-types";
import React from "react";

import TableMenuItemMenu from "@components/TableMenuItemMenu";
import { uniqueKey } from "@utils/react";

const useStyles = makeStyles(() => ({
  menu: {
    "& > .MuiPopover-paper": {
      overflow: "visible",
    },
  },
  divider: {
    marginTop: "8px",
    marginBottom: "8px",
  },
}));

function TableMenu(props) {
  const classes = useStyles();

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  function closeMenu() {
    setAnchorEl(null);
  }

  function openMenu(anchorElement) {
    setAnchorEl(anchorElement);
  }

  function handleClick(event) {
    openMenu(event.currentTarget);
  }

  function handleClose() {
    closeMenu();
  }

  return (
    <div>
      <IconButton onClick={handleClick}>
        <MoreVertIcon />
      </IconButton>
      <Menu
        id={props.id}
        className={classes.menu}
        anchorEl={anchorEl}
        keepMounted
        open={open}
        onClose={handleClose}
      >
        {props.options.map((option) => {
          if (option.separator) {
            return (
              <Divider
                key={uniqueKey("table-menu-divider")}
                className={classes.divider}
              />
            );
          }

          if (option.menu) {
            return (
              <TableMenuItemMenu
                option={option}
                data={props.data}
                onCloseMenu={() => closeMenu()}
              />
            );
          } else {
            return (
              <MenuItem
                key={uniqueKey("table-menu-option")}
                onClick={() => {
                  closeMenu();
                  option.onClick(props.data);
                }}
              >
                {option.icon && (
                  <ListItemIcon>
                    <option.icon fontSize="small" />
                  </ListItemIcon>
                )}
                <Typography>{option.label}</Typography>
              </MenuItem>
            );
          }
        })}
      </Menu>
    </div>
  );
}

TableMenu.propTypes = {
  id: PropTypes.string,
  options: PropTypes.array.isRequired,
  data: PropTypes.object.isRequired,
};

TableMenu.defaultProps = {
  id: "",
  options: [],
  data: null,
};

export default TableMenu;
